import ProductService from "@/app/services/ProductService.js"
import { types } from "@/app/types/types";
import { importProductsAndGroupsModeEnum } from "@/app/enums/common";

const state =
{
	[types.STATE_PRODUCTS]: []
};

const getters =
{
	[types.GET_PRODUCTS]: (state) =>
	{
		return state[types.STATE_PRODUCTS]
	},

	[types.GET_PRODUCT]: (state) => id =>
	{
		var products = state[types.STATE_PRODUCTS];

		for (const product of products)
		{
			if (product.id == id)
				return product;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_PRODUCTS]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_PRODUCTS] = payload
	},

	[types.MUTATE_ADD_PRODUCT]: (state, payload) =>
	{
		state[types.STATE_PRODUCTS].push(payload);
	},

	[types.MUTATE_UPDATE_PRODUCT]: (state, payload) =>
	{
		//let index = state[types.STATE_PRODUCTS].findIndex(product => product.id == payload.id)
		//state[types.STATE_PRODUCTS].splice(index, 1, payload)
		let product = state[types.STATE_PRODUCTS].find((product) => { return product.id == payload.id });

		if (product)
		{
			product = payload
		}
	},

	[types.MUTATE_DELETE_PRODUCT]: (state, payload) =>
	{
		//let index = state[types.STATE_PRODUCTS].findIndex(product => product.id == payload.id)
		//state[types.STATE_PRODUCTS].splice(index, 1)
		state[types.STATE_PRODUCTS] = state[types.STATE_PRODUCTS].filter((product) => { return product.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_PRODUCTS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTS, payload: payload })
		
		return ProductService.getProducts(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_PRODUCTS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTS, message: error, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_PRODUCT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PRODUCT, payload: payload })

		return ProductService.getProduct(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PRODUCT, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PRODUCT, message: error });
			return error.response
		});
	},

	[types.ACTION_ADD_PRODUCT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_PRODUCT, payload: payload })

		return ProductService.addProduct(payload).then(response =>
		{
			commit(types.MUTATE_ADD_PRODUCT, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_PRODUCT, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_PRODUCT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_PRODUCT, payload: payload })

		return ProductService.updateProduct(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PRODUCT, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_PRODUCT, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DELETE_PRODUCT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_PRODUCT, payload: payload })

		return ProductService.deleteProduct(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_PRODUCT, payload);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_PRODUCT, message: error.response.statusText, payload: payload });
			return error.response
		});
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
